import { useNavigate, useSearchParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { useState } from "react";
import AppSnackbar from "../components/Common/Snackbar/AppSnackbar";
import NotificationForm from "../components/inAppNotificationManagement/NotificationForm";
import NotificationPageLayout from "../components/inAppNotificationManagement/NotificationPageLayout";
import { withNotificationPageAuth } from "../components/inAppNotificationManagement/notificationPageAuth";
import {
  buildNotificationListRouteState,
  getInAppNotificationPermission,
  IN_APP_NOTIFICATION_ROUTES,
} from "../constants/inAppNotificationConstant";

const CreateNotificationPage = ({ userRoles = [], userLevel = 0 }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [apiFeedbackMsg, setApiFeedbackMsg] = useState({
    open: false,
    type: "info",
    msg: "",
  });

  const targetType =
    searchParams.get("targetType") === "user-specific" ? "user-specific" : "broadcast";

  const canCreate = getInAppNotificationPermission(
    userRoles,
    targetType === "broadcast" ? "createBroadcast" : "createUserSpecific",
    userLevel,
  );

  const navigateBack = (refresh = false, feedback) => {
    navigate(IN_APP_NOTIFICATION_ROUTES.list, {
      state: buildNotificationListRouteState({
        targetType,
        refresh,
        feedback,
      }),
    });
  };

  if (!canCreate) {
    return (
      <NotificationPageLayout
        breadcrumbLabel="Create Notification"
        title="Create Notification"
        subtitle="Set up a new in-app notification for the MirAie mobile app."
      >
        <Typography color="text.secondary">
          You do not have permission to create this notification type.
        </Typography>
      </NotificationPageLayout>
    );
  }

  return (
    <NotificationPageLayout
      breadcrumbLabel="Create Notification"
      title="Create Notification"
      subtitle="Set up a new in-app notification for the MirAie mobile app."
    >
      <NotificationForm
        mode="create"
        defaultTargetType={targetType}
        onCancel={() => navigateBack()}
        onSuccess={({ message }) =>
          navigateBack(true, message ? { type: "success", msg: message } : undefined)
        }
        feedbackHandler={(feedback) =>
          setApiFeedbackMsg({ ...feedback, open: true })
        }
      />

      <AppSnackbar
        open={apiFeedbackMsg.open}
        type={apiFeedbackMsg.type}
        message={apiFeedbackMsg.msg}
        onClose={() => setApiFeedbackMsg((prev) => ({ ...prev, open: false }))}
      />
    </NotificationPageLayout>
  );
};

export default withNotificationPageAuth(CreateNotificationPage);
